module.exports = __webpack_public_path__ + "img/pr-3.a61a3c0d.png";